import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetPatientAppointmentCountDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useExistsAppointment = (patientId: string) => {
  const [getAppointments, { data, loading }] = useLazyQuery(GetPatientAppointmentCountDocument);
  const exists = (getNode(data, 'Patient')?.appointments.nodesCount || 0) > 0;

  useEffect(() => {
    if (patientId) {
      getAppointments({ variables: { patientId } });
    }
  }, [getAppointments, patientId]);

  return { exists, loading };
};
